import React, { useState, useEffect } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { DialogContentText, TextField } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';

export default function StopCarpentryOrderDialog(props) {

    const classes = useStyles();
    const { t } = useTranslation();
    const [stopReason, setStopReason] = useState(null);
    const [stopComment, setStopComment] = useState("");
    const [error, setError] = useState(false);
    const [disableStop, setDisableStop] = useState(true);
    const [stopReasons, setStopReasons] = useState(null);

    useEffect(() => {
        if (stopReasons == null) {
            dataService.GetStopReasons().then(reasons => {
                setStopReasons(reasons);
            }).catch((error) => { toast.error(error, { position: "top-center" }) });
        }
    });

    const handleStopReason = (event) => {
        setStopReason(event.target.value)
        if (event.target.value === 3 && stopComment === "") {
            setDisableStop(true);
        }
        else if (event.target.value !== "") {
            setDisableStop(false);
        }
    }

    const handleStopComment = (event) => {
        if (event.target.value !== null && event.target.value !== undefined) {
            setStopComment(event.target.value);
        }

        if (event.target.value !== "") {
            setDisableStop(false);
        } else {
            setDisableStop(true);
        }
        if (error && stopComment !== "") {
            setError(false);
        }
    }

    const stopOrder = () => {
        if (stopReason === 3 && !stopComment) {
            setError(true);
        } else {
            props.action(stopComment, stopReason);
            props.closeDialog();
        }
    }

    return (

        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
        >   <div className={classes.headerIcon}>
                <div className={classes.stopIcon}>
                </div>
            </div>
            <DialogTitle className={classes.dialogTitle}>
                {props.dialogTitle}
            </DialogTitle>
            <DialogContentText className={classes.dialogContext}>
                {props.dialogContext}
            </DialogContentText>
            <div className={classes.dialogTable}>
                <div className={classes.row}>
                    <FormControl fullWidth >
                        <InputLabel>{t("Reason")}</InputLabel>
                        <Select
                            value={stopReason}
                            label={t("Reason")}
                            onChange={handleStopReason}>
                            {stopReasons != null && stopReasons.map((order) => {
                                return <MenuItem key={"ReasonID_" + order.reasonId} value={order.reasonId}>{order.name}</MenuItem>
                            }
                            )}
                        </Select>
                    </FormControl>
                </div>
                {stopReason === 3 &&
                    <div className={classes.row}>
                        <TextField error={error} onChange={(e) => handleStopComment(e)} value={stopComment} id={props.productionOrder.productionOrderReference} key={"comment"} label={t("Extra information")} className={classes.comment} multiline maxRows={4} rows={4} fullWidth variant="outlined" />
                    </div>}
            </div>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.cancelButton} onClick={() => props.closeDialog()}>
                        {t("CANCEL")}
                    </Button>
                    <Button className={classes.stopButton} disabled={disableStop} onClick={() => stopOrder(stopReason, stopComment)} >
                        <div className={classes.whiteSquare}></div>{t("STOP")}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}

const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "620px !important",
        margin: "auto"
    },
    buttons: {
        textAlign: "center",
        marginLeft: "auto",
        marginRight: "auto",
        width: "235px",
    },
    stopButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        backgroundColor: "#D84949",
        '&:hover': {
            backgroundColor: "#D84949",
        },

        '&:disabled>span>div': {
            backgroundColor: "rgba(0, 0, 0, 0.26)",
        },
        margin: "3px",
        width: "110px",
        marginTop: "20px",
        marginBottom: "20px"
    },
    cancelButton: {
        color: FlagstoneTheme.palette.primary.main,
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        backgroundColor: "#E6E8FE",
        '&:hover': {
            backgroundColor: "#E6E8FE",
        },
        margin: "3px",
        width: "110px",
        marginBottom: "30px",
        marginTop: "20px",
        float: "left"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "0px",
        paddingBottom: "0px",
    },
    dialogContext: {
        color: "#D84949",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center"
    },
    headerIcon: {
        height: "80px",
        width: "100%",
        marginTop: "10px",
        textAlign: "center",
        padding: "20px",
        boxSizing: "border-box"
    },
    row: {
        width: "100%",
        alignContent: "center",
        justifyContent: "center",
    },
    formControl: {
        width: "100%",
        paddingTop: "20px",
        marginBottom: "20px",
    },
    valueCell: {
        width: "40%",
        textAlign: "right",
        float: "left",
        color: "#020100",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'regular',
    },
    nameCell: {
        width: "60%",
        textAlign: "left",
        float: "left",
        color: "#020100",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
    },
    dialogTable: {
        width: "100%",
        paddingLeft: "60px",
        paddingRight: "60px",
        boxSizing: "border-box",
        alignItems: "center",
    },
    whiteSquare: {
        width: "15px",
        height: "15px",
        backgroundColor: "white",
        borderRadius: "4px",
        marginRight: "10px"
    },
    stopIcon: {
        backgroundColor: "#D84949",
        width: "50px",
        height: "50px",
        borderRadius: "10px",
        marginLeft: "auto",
        marginRight: "auto"
    },
    comment: {
        marginTop: "20px"
    },

}));
